import { useEffect, useState } from 'react';

interface ISELECT_INPUT {
  id: string;
  label: string;
  value: string;
  optionsArray: Array<{ id: string; label: string; value: string }>;
  onChange: (fieldName: string, value: string | number, index?: number) => void;
  placeholder: string;
  showLabel?: boolean;
  required?: boolean;
  hidden?: boolean;
  index?: number;
  labelClass?: string;
  bottomMargin?: boolean;
}
export const SelectInput = ({
  id,
  label,
  optionsArray,
  onChange,
  placeholder,
  value,
  showLabel = false,
  required = false,
  hidden = false,
  index = 0,
  labelClass = '',
  bottomMargin = true,
}: ISELECT_INPUT): JSX.Element => {
  const [selectedValue, setSelectedValue] = useState<string | number>(value);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleOnOption = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const val = e.target.value;
    setSelectedValue(val);
    if (index) {
      onChange(e.target.id, val, index);
    } else {
      onChange(e.target.id, val);
    }
  };

  return (
    <div
      className={`${bottomMargin ? 'pb-2 sm:pb-1' : ''} ${
        hidden ? 'hidden' : ''
      }`}
    >
      <label
        htmlFor={id}
        className={`text-base text-font-500- font-medium ${labelClass} ${
          showLabel ? '' : 'hidden'
        }`}
      >
        {label} {required && <span className="text-red-350">*</span>}
      </label>
      <div className="flex mt-2 sm:mt-1">
        <select
          id={id}
          className={`appearance-none border border-grey-300 rounded-sm text-base w-full h-12 px-2 pr-12 bg-white sm:text-sm sm:h-9 bg-[center_right_0.75rem] bg-[length:35px_35px] sm:bg-[length:28px_28px]`}
          placeholder={`${placeholder} ${required ? '*' : ''}`}
          name={id}
          value={selectedValue}
          onChange={handleOnOption}
          style={{
            backgroundImage: `url('https://assets.clear.in/cleartax/images/1731309883_test.svg')`,
            backgroundRepeat: 'no-repeat',
            backgroundColor: 'white',
            backgroundPosition: 'calc(100% - 0.7rem) center',
            backgroundClip: 'padding-box',
          }}
        >
          {optionsArray.map((item) => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
